export default {
  name: 'Header section - 1',
  tab: 'header',
  type: 'navigation-default-section',
  content: {
    logo: '/storage/media/Logo/combination_logo_outline_transparent.svg',
    menu: 'default'
  },
  design: {
    'background-color': 'var(--background-color)',
    padding: '15px',
    'logo-width': '150px',
    'menu-font-family': 'inherit',
    'menu-text-color': 'var(--text-light-color)',
    'menu-font-size': '14px'
  },
  layout: {
    'content-container-fluid': '0',
    centered: '0',
    absolute: '1',
    'absolute-background-opacity': '0',
    'show-toggle': 'sm'
  },
  advanced: {
    'stick-on-scroll': '0',
    'sticky-background-color': 'var(--secondary-color)',
    'sticky-background-opacity': '1',
    'active-style': 'underline-accent'
  }
}
